import Game from "./scenes/game/Game";
import Intro from "./scenes/intro/Intro";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [Intro, Game],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: Intro.KEY,

    curGameType: "LISTEN",
    numUnlocked: 0,
    curSnakeIndex: 0,
    hasUnlocked: false,
    isMuted: false,
    units: 1,
    snakeTypes: [
        {colors: [0x9fd154, 0x10877b]},
        {colors: [0xf28b46, 0x9e1336]},
        {colors: [0xf2e6c6, 0x63484f]},
        {colors: [0xa6dde0, 0x226a84]},
        {colors: [0xf2735a, 0x84204b]},
        {colors: [0xdb637d, 0xffc2b8]},
        {colors: [0xffedb8, 0xf59458]},
        {colors: [0xd2e074, 0x992959]},
    ],
    gameTypes: {
        COUNT: {
            background: "bg_meadow",
            curCorrect: 0,
            stagesComplete: 0,
        },
        LISTEN: {
            background: "bg_forest",
            curCorrect: 0,
            stagesComplete: 0,
        },
        READ: {
            background: "bg_rocks",
            curCorrect: 0,
            stagesComplete: 0,
        }
    }
}
